<template>
    <div class="container-fluid">

        <div class="card shadow-lg p-4">
            <div class="text-center">
                <h2 class="mb-3">Pay Subscription Via Mpesa</h2>
                <hr />
                <h5 class="py-3 text-primary">
                    {{ convertCurrencyToShillings(billingForm.is_annual ? (subscriptionPlan.subscriptionplan.amount * 11) : subscriptionPlan.subscriptionplan.amount) }}
                </h5>
                <p class="text-muted">
                    Current Plan: <strong>{{ subscriptionPlan.subscriptionplan.name }}</strong>
                </p>
                <p class="text-muted">
                    Due Date: <strong>{{ subscriptionPlan.due_date }}</strong>
                </p>
                <div>
                    <p class="text-primary">Switch to an annual plan and <b>Get 1 Month Free!</b></p>
                </div>
                <div class="custom-control custom-switch">
                                <input v-model="billingForm.is_annual" type="checkbox" class="custom-control-input" id="customSwitch1">
                                <label class="custom-control-label" for="customSwitch1">Change to Annual plan</label>
                </div>
            </div>
            <hr />
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <form @submit.prevent="paySubscriptionViaMpesa">
                        <div class="mb-3">
                            <label class="form-label">Enter your Mpesa Number (To Prompt)</label>
                            <vue-tel-input v-on:validate="validatePhoneNumber" v-model="billingForm.phoneNumber"></vue-tel-input>
                            <small class="text-muted">You will receive a request to input your M-Pesa PIN.</small>
                        </div>
                        <button type="submit" class="btn btn-primary btn-lg w-100">Continue to Pay</button>

                    </form>
             <p><a v-b-modal="'paybill-modal'" class="text-big">Use paybill instead?</a> </p><p>Having a challenge?<a class="text-primary" target="_blank" href="https://wa.me/254725445898"> WhatsApp us</a>  </p>
                </div>
            </div>
        </div>
        <b-modal id="paybill-modal" hide-footer>
    <div class="text-center">
        <p class="text-danger" v-if="c2berror">{{ c2berror }}</p>
        <h4>Dukakit Paybill</h4>
    </div>
    <div class="text-left">
        <p>To use M-PESA Paybill, follow these steps:</p>
        <ol class="pl-3">
            <li>Select <b>M-PESA</b></li>
            <li>Select <b>Lipa Na M-PESA</b></li>
            <li>Select <b>Paybill</b></li>
            <li>Enter Paybill: <b>4109900</b></li>
            <li>Enter Account: <b>{{ subscriptionPlan.billing_account }}</b></li>
            <li>Enter Amount: <b>    {{ convertCurrencyToShillings(billingForm.is_annual ? (subscriptionPlan.subscriptionplan.amount * 11) : subscriptionPlan.subscriptionplan.amount) }}</b> or more</li>
            <li>Enter your <b>M-PESA PIN</b> and confirm</li>
            
         
        </ol>
        <button class="btn btn-primary btn-sm" @click="confirmMpesaC2B(subscriptionPlan.billing_account)">Confirm Transaction</button>
    </div>
</b-modal>
 

            <div class="text-center">
                <h2>Recent Transactions</h2>

            </div>
            <div class="container-fluid">
                <table v-if="billingTransactions" class="table table-striped table-responsive-sm">
            <thead>
               
                <td>Transaction ID</td>
                <td>Amount</td>
                <td>Phone</td>
                <td>Status</td>
                <td>Date</td>
            </thead>
            <tbody>
                <tr v-for="transaction in billingTransactions">
                    <td>{{ transaction.MpesaReceiptNumber }}</td>
                    <td>{{ transaction.amount }}</td>
                    <td>{{ transaction.PhoneNumber }}</td>
                    <td>
                        <span v-if="transaction.MpesaReceiptNumber " class="badge badge-success">Success</span>
                        <span v-else class="badge badge-danger">Pending</span>
                    </td>
                    <td>{{ formatDate(transaction.updated_at,'Y-MM-DD hh:mm a') }}</td>

                </tr>
            </tbody>
            </table>
            </div>
            
         
 
        <b-modal ref="process_mpesa" id="modal-center" no-close-on-backdrop centered hide-footer>
            <div class="text-center pt-3">

                <div v-html="statusHolder">

                </div>


            </div>

        </b-modal>

    </div>
</template>

<script>
    export default {
        name: "topup",
        props:['admin_configs'],
        data(){
            return{
                mpesanumbererror:'',
                top_up_amount:'',
                mpesanumber:'',
                smstopup:0,
                billingForm:{
                    validPhoneMessage:'',
                    phoneNumber:'',
                    is_annual:false
                },
                billingTransactions:{},
                subscriptionPlan:{
                    subscriptionplan:{}
                },
                c2berror:'',
                checkMpesaResponsePoll: null,
                statusHolder: '<div class="spinner-border text-primary" role="status">\n' +
                    '  <span class="sr-only">Loading...</span>\n' +
                    '</div>' +
                    '<p>Please check your phone for M-Pesa pin input to confirm.... </p>',
            }
        },
        mounted()
        {
            this.getBillingPlan()
        },
        
        methods:{
            paySubscriptionViaMpesa()
          {
            
      
              if(this.billingForm.phoneNumber !=='')
              {
                axios.post('/api/pay-monthly-subscription',{...this.billingForm}).then(results=>{
                    if(results.status === 200)
                    {
                        this.$refs['process_mpesa'].show();
                   
                       this.checkMpesaResponsePoll =  setInterval(() => {
                            axios.get('/api/validate-billing-transaction',{params:{bill_id:results.data.id}}).then(checkerresults=>{
                              
                                if (checkerresults.data.message === 1)
                                {
                                    this.statusHolder="<div class=\"success-checkmark\">\n" +
                                        "  <div class=\"check-icon\">\n" +
                                        "    <span class=\"icon-line line-tip\"></span>\n" +
                                        "    <span class=\"icon-line line-long\"></span>\n" +
                                        "    <div class=\"icon-circle\"></div>\n" +
                                        "    <div class=\"icon-fix\"></div>\n" +
                                        "  </div>\n" +
                                        "</div> <div class='text-center'> <h6 class='text-smanel-gray-lvl3'>Your payment has been received and your account has been credited</h6> </div>"
                                    setInterval(() => {
                                        // clear polling ID
                                        clearInterval(this.checkMpesaResponsePoll);
                                        // CLOSE MODAL
                                        this.$refs['process_mpesa'].hide();
                                        window.location.href='/dashboard';

                                    },3000)
                                }
                                if(checkerresults.data.message === 0)
                                {
                                    this.statusHolder = "<div class=\"container text-center\">\n" +
                                        "<h5 class=\"text-danger text-smanel-50\">\n" +
                                        "<i class=\"bi bi-x-circle\"></i>\n" +
                                        "</h5>\n" +
                                        "<p>There was an issue with payment ("+ checkerresults.data.description +") </p>\n" +
                                        "\n" +
                                        "<a class=\"btn btn-success\" href=\"/billing-and-plans\">Retry Payment</a>\n" +
                                        "\n" +
                                        "</div>"
                                }

                            }).catch()
                        }, 10000)

                    }

                }).catch()
              }
             
          },
          getBillingPlan()
          {
                axios.get('/api/subscription-plan').then(results=>{
                    this.subscriptionPlan = results.data
                    this.getBillingTransactions()
                }).catch()
          },
          getBillingTransactions()
          {
                axios.get('/api/billing-transactions').then(results=>{
                    this.billingTransactions = results.data
                }).catch()
          },
            FixedAmount(amount)
            {
                this.mpesanumbererror = '';
                this.top_up_amount=amount;
            },
            async confirmMpesaC2B(account)
            {
                await axios.get(`/api/confirm-c2b-transactions?account=${account}`).then(results=>{
                    if(results.status===200 && results.data.message === 'successfull')
                    {
                        window.location.href='/dashboard'
                    }
                    else{
                        this.c2berror = results.data.message
                    }
                }).catch(error=>{
                    this.$toasts.push({
                        'type':'error',
                        'message':'There was an error'
                    })
                })
            },
            validatePhoneNumber(phoneNumber) {
               this.billingForm.validPhoneMessage = (phoneNumber.valid) ? '' : "Enter a valid phone number"
            },
            formatDate(date, format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            }
        }

    }
</script>

<style scoped>

</style>